export enum MessagesEnum {
  success = 'success',
  danger = 'danger',
  // primary = 'primary',
  info = 'info',
  warning = 'warning',
  loading = 'loading'
}
